<template>
    <v-dialog content-class="modal-card" v-model="dialogControl">
        <v-card class="center">
            <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                <v-icon>fas fa-times</v-icon>
            </v-btn>
            <v-flex class="card-margin" v-if="!showTextArea">
                <v-row class="center">
                    <h2>Select Branding Strategy</h2>
                </v-row>
                <v-row style="justify-content: center;">
                    <v-col class="input-dialog-area file-area" cols="4" sm="5" md="3">
                        <v-flex class="center input-container">
                            <v-icon>fas fa-file-upload</v-icon>
                            <span v-if="file">{{ fileName }}</span>
                            <span v-else>Upload File</span>
                        </v-flex>
                        <input @change="fileChanged" type="file" accept="image/*" id="dialogFileUpload" ref="dialogFileUpload" />
                    </v-col>
                    <v-col class="input-dialog-area branding-request-area" cols="4" sm="5" md="3">
                        <v-flex @click="showTextArea = true" class="center input-container">
                            <v-icon>fas fa-store</v-icon>
                            <span>Request Branding</span>
                        </v-flex>
                    </v-col>
                </v-row>
                <v-row v-if="file" class="center">
                    <v-col cols="7">
                        <v-text-field v-model="cardTitle" outlined label="Title"></v-text-field>
                    </v-col>
                </v-row>
            </v-flex>
            <v-flex class="card-margin" v-else-if="showTextArea">
                <v-textarea v-model="description" solo label="Branding Description"></v-textarea>
                <v-flex style="margin-top: -25px;" class="end">
                    <span>{{description.length}}/100</span>
                </v-flex>
                <v-row>
                    <v-btn v-if="dueDate" @click="dueDate = null; dateMenu = false;" icon>
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                    <p class="mt-1">Due Date:</p>
                    <v-menu
                        v-if="!dueDate"
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on" v-bind="attrs" @click="dateMenu = false" icon>
                                    <v-icon>far fa-calendar-check</v-icon>
                                </v-btn>
                            </template>
                            <v-date-picker no-title :min="today" v-model="dueDate">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="dateMenu = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="dueDate = null">
                                    Clear
                                </v-btn>
                                <v-btn text color="primary" @click="$refs.dateMenu.save(dueDate); dateMenu = false;">
                                    OK
                                </v-btn>
                            </v-date-picker>
                    </v-menu>
                    <span v-else class="mt-1 ps-1">{{ dueDate }}</span>
                </v-row>
            </v-flex>
            <site-button
                v-if="canSubmit"
                :colNum="6"
                :marginNumber="3"
                @click-event="submitChanges"
                iconString="fas fa-mail-bulk"
                btnType="text"
                text="Submit Branding Request"
                colorClasses="secondary-icon"
                iconColor="primary-icon"
            ></site-button>
        </v-card>
    </v-dialog>
</template>

<style scoped>
::v-deep .v-dialog{
    overflow-y: hidden !important;
    border-radius: 15px;
    max-height: 70% !important;
    max-width: 55%;
}

.card-margin{
    padding: 2.5em 1.5em .5em 1.5em;
}

</style>

<script>
import SiteButton from '../common/SiteButton.vue';

export default {
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        'site-button': SiteButton
    },
    data: () => ({
        file: null,
        showTextArea: false,
        description: '',
        dueDate: null,
        dateMenu: false,
        cardTitle: ''
    }),
    methods: {
        fileChanged(events){
            const uploadedFile = events.target.files[0];
            if(uploadedFile.size < 5242880){
                this.file = uploadedFile;
            } else {
                console.log('error file too big');
            }
        },
        submitChanges(){
            if(this.showTextArea){
                this.$emit('send-email', {
                    desc: this.description,
                    dueDate: this.dueDate
                });
            } else {
                const reader = new FileReader()
                const file = this.file;
                reader.readAsDataURL(this.file);
                reader.onload = () => {
                    console.log(reader.result);
                    this.$emit('uploaded', {
                        label: this.cardTitle,
                        srcFile: file,
                        srcString: reader.result.toString()
                    });
                };
            }
            this.dialogControl = false;
        }
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog
            },
            set(newVal) {
                this.showTextArea = false;
                this.description = '';
                this.file = null;
                this.$emit('set-dialog-control', newVal)
            },
        },
        isMobile() {
            return screen.width <= 760
        },
        fileName(){
            return this.file.name;
        },
        canSubmit(){
            return this.showTextArea ? 
                this.description.length > 100 : 
                this.file && this.cardTitle;
        },
        today(){
            return new Date().toISOString().substring(0,10);
        },
        dueDateText(){
            return this.dueDate
        }
    },
}
</script>
